<template>
    <transition name="toggleContentComponent">
        <article class="imageTextCarousel" v-if="ready">
            <Carousel :activeIndex="activeIndex">
                <section v-for="slide in properties?.slides">
                    <div class="img-container">
                        <img v-if="slide.image" :src="getMediaPath(slide.image?.src)">
                    </div>
                    <div class="text-container" v-if="slide.title || slide.description">
                        <h2>{{ slide.title }}</h2>
                        <div class="scroll-container" v-html="slide.description"></div>
                    </div>
                </section>
            </Carousel>
            <div class="navigation" v-if="properties.slides.length > 1">
                <button class='nav-button' @click="decrementActiveIndex" :class="this.activeIndex === 0 && 'inactive'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22.243" height="38.485" viewBox="0 0 22.243 38.485">
                        <path id="_" data-name="&lt;" d="M240.595,656l-15,15,15,15" transform="translate(-222.595 -651.757)"
                            fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="6" />
                    </svg>
                </button>
                <button class="dot" v-for="dot, index in properties.slides.length"
                    :class="index === activeIndex ? 'active' : ''" @click="activeIndex = index"></button>
                <button class='nav-button' @click="incrementActiveIndex"
                    :class="this.activeIndex >= this.properties?.slides?.length - 1 && 'inactive'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22.242" height="38.485" viewBox="0 0 22.242 38.485">
                        <path id="_" data-name="&lt;" d="M225.595,656l15,15-15,15" transform="translate(-221.352 -651.757)"
                            fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="6" />
                    </svg>
                </button>
            </div>
            <ShareButton />
        </article>
    </transition>
</template>

<script>
import ShareButton from '../../ui/ShareButton.vue'

export default {
    props: ['properties', 'slug'],
    components: {
        ShareButton
    },
    data() {
        return {
            ready: false,
            activeIndex: 0,
        }
    },
    mounted() {
        this.ready = true;
    },
    methods: {
        getMediaPath(src) {
            return app.api.Utils.getMediaPath(src)
        },
        closeComponent() {
            this.$emit("closeComponent", this.slug)
        },
        incrementActiveIndex() {
            if (this.activeIndex >= this.properties?.images?.length - 1) return;
            this.activeIndex++;
        },
        decrementActiveIndex() {
            if (this.activeIndex === 0) return;
            this.activeIndex--;
        },
    }
}
</script>

<style lang="scss" scoped>
.imageTextCarousel {
    width: 100%;
    height: 100%;
    position: relative;
    background: var(--background-gradient);
}

section {
    object-fit: cover;
    min-width: 100%;
    height: 100%;
    display: flex;
    
    > * {
        flex-basis: 50%;
        flex-grow: 1;
    }

}

.img-container img {
    object-fit: cover;
    width: 100%;
    height: 100%;
}

.navigation {
    position: absolute;
    bottom: 50px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
}

.nav-button {
    width: 60px;
    height: 60px;
    background-color: var(--main-color);
    pointer-events: all;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform .2s ease;
    margin: 0 20px;

    &:hover {
        transform: scale(1.05);
    }
}


.dot {
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 3.5px solid white;
    transition: all .25 ease;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        border-radius: 50%;
        background-color: var(--dark-grey);
        opacity: .3;

        transition: all .25s ease;

    }

    &.active {
        &::before {
            opacity: 1;
            background-color: white;
        }
    }

    transition: transform .2s ease;

    &:hover {
        transform: scale(1.05);
    }
}

.inactive {
    opacity: .2;
    pointer-events: none;
}
</style>